import {
  PersonalInformation,
  LocationDetails,
  ContactInformation,
  PhysicalAttributes,
  ProfessionalPreferences,
} from "../../pages/index";
export default (step, isOfScreen) => {
  const stepComponents = [
    PersonalInformation,
    LocationDetails,
    ContactInformation,
    ProfessionalPreferences,
  ];
  if (isOfScreen === false) {
    stepComponents.splice(3, 0, PhysicalAttributes);
  }

  const StepComponent = stepComponents[step];
  return { StepComponent };
};
